import React, { useCallback } from "react";

const CategoryCard = ({
  category,
  data,
  computed,
  onKgChange,
  onChange,
  onShowImpurity,
}) => {
  const handleKgChange = useCallback(
    (e) => {
      const { value } = e.target;
      if (value === "" || /^(\d+(\.\d{0,2})?)?$/.test(value)) {
        onKgChange(value);
      }
    },
    [onKgChange]
  );

  if (!data) return null;

  const hasError = !!data.kgError;
  const amountInNaira = computed?.amountInNaira ?? 0;
  const discountPercentage = computed?.discountPercentage ?? 0;

  return (
    <div className="cardss mt-4 mb-4">
      {/* Card header */}
      <div className="d-flex justify-content-between align-items-center">
        <p className="mb-0" style={{ fontWeight: "500", fontSize: "16px" }}>
          {category.label}
        </p>
        <a href="#" style={{ color: "#231F20", fontSize: "14px" }}>
          View Category Info
          <span style={{ color: "#c4da00", fontSize: "12px" }} className="ml-1">
            &#62;
          </span>
        </a>
      </div>

      {/* KG input */}
      <div className="mb-3 mt-2">
        <label className="mb-1 form-label">{category.label}</label>
        <input
          type="text"
          className={`form-control form-control-lg inputStyle ${
            hasError ? "is-invalid" : ""
          }`}
          placeholder="Enter weight in KG"
          value={data.kg}
          onChange={handleKgChange}
        />
        {hasError && (
          <div className="invalid-feedback d-block" style={{ fontSize: "12px" }}>
            {data.kgError}
          </div>
        )}
      </div>

      {/* Amount in Naira (price_per_kg × kg) */}
      <div className="mb-3">
        <label className="mb-1 form-label">Amount in Naira</label>
        <div
          style={{ backgroundColor: "#F8FFF8", border: "none" }}
          className="d-flex justify-content-between align-items-center"
        >
          <input
            type="text"
            className="form-control form-control-lg inputStyle"
            placeholder="₦0.00"
            style={{ backgroundColor: "#F8FFF8", border: "none" }}
            value={`₦${hasError ? 0 : amountInNaira}`}
            disabled
          />
        </div>
      </div>

      {/* Discount Percentage (tier.discount_percentage — flat % from tier) */}
      <div className="mb-3">
        <label className="mb-1 form-label">Discount Percentage</label>
        <input
          type="text"
          className="form-control form-control-lg inputStyle"
          placeholder="0%"
          style={{ backgroundColor: "#F8FFF8", border: "none" }}
          value={hasError ? "0%" : `${discountPercentage}%`}
          disabled
        />
      </div>

      {/* Impurity link — commented out, replaced by discount percentage field above */}
      {/* {!data.kgError && (
        <div className="text-center" onClick={onShowImpurity}>
          <p style={{ color: "#231F20", fontSize: "14px", cursor: "pointer" }}>
            Noticed Impurities? Reduce price
            <span style={{ color: "#c4da00", fontSize: "12px" }} className="ml-1">
              &#62;
            </span>
          </p>
        </div>
      )} */}
    </div>
  );
};

export default CategoryCard;
